export const PROTOCOL = 'https://';
export const AUTH = 'auth.mail.ru';
export const ACCOUNT_HOST = 'account.mail.ru';
export const CGI_BIN = '/cgi-bin';
export const CGI_BIN_MY = `${CGI_BIN}/my`;

const PAYMENT_ABS = 'm.my.mail.ru/cgi-bin/app/paymentm';

const EXTERNAL_URLS = {
	REST_API: `/platform/api`,
	PAYMENTM_ABS: `${PROTOCOL}${PAYMENT_ABS}`,
};

export const URLS_CGI = {
	PAYMENT_M: `${CGI_BIN}/app/paymentm`, // old
	LOG_IN: `${CGI_BIN_MY}/login`, // old
	LOG_OUT: `${CGI_BIN}/logout`, // old
	WAPI: `${CGI_BIN_MY}/wapi`,
	AJAX: `${CGI_BIN_MY}/ajax`,
	CATALOG_XML: `${CGI_BIN}/app/catalogxml`,
	APP_CONFIGS: `${CGI_BIN_MY}/wapi?method=notify.get_subscriptions&limit=12`,
	MOBILE_REDIRECT: `${CGI_BIN}/app/mobile_redirect`,
};

const URLS_APPS = {
	APPS: '/apps',
	CATALOG_INSTALLED: `/installed`,
	CATALOG_GENRE: `/genre`,
	CATALOG_NEW: `/new`,
	CATALOG_POPULAR: `/popular`,
	PAYMENT_RESULT: `/payment-result`,
};

export const URLS = {
	MAIN: '/',

	...URLS_CGI,
	...EXTERNAL_URLS,
	...URLS_APPS,

	REGISTRATION: '/my/registration',
	FRIENDS: '/friends',
	VISITORS: '/visitors',
	VIDEO: '/video',
	MUSIC: '/music',
	COMMUNITIES: '/my/communities',
	MAIL: '/mail',
	DIALOGUES: `/my/dialogues`,
	NOTIFICATIONS: `/my/notifications`,
	ACCOUNT_MAIL_RU_LOGIN: `${PROTOCOL}${ACCOUNT_HOST}/login`,
	ACCOUNT_MAIL_RU_REGISTRATION: `${PROTOCOL}${ACCOUNT_HOST}/signup`,
	LOGOUT: `${PROTOCOL}${AUTH}${URLS_CGI.LOG_OUT}`, // old
};
